import { Box } from '@mui/material';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import { PublicHeader } from './PublicHeader';
import { PublicFooter } from './PublicFooter';
import { WhatsappFab } from '@/components/WhatsappFab';
import { SolarBackground } from '@/components/background/SolarBackground';

export function PublicLayout() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100dvh' }}>
      {/* Decorative layer, behind everything. Sections with an opaque tone
          cover it, so the schematics surface in the open bands only. */}
      <SolarBackground />

      <PublicHeader />
      <Box component="main" id="main" sx={{ flex: 1, position: 'relative', zIndex: 1 }}>
        <Outlet />
      </Box>
      <Box sx={{ position: 'relative', zIndex: 1 }}>
        <PublicFooter />
      </Box>
      <WhatsappFab />
      <ScrollRestoration />
    </Box>
  );
}
